import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { forms as Forms } from '@breezeway/brzw-components';
import { format } from '@breezeway/brzw-react-core';

const FormControlPhoneSelect = props => {
  const {
    className,
    defaultCountry,
    id,
    label,
    names,
    options,
    placeholder,
    required,
    rerenderKey,
  } = props;

  const countryCodeInput = props[names[0]].input;
  const countryDialCodeInput = props[names[1]].input;
  const phoneNumberInput = props[names[2]].input;
  const phoneNumberMeta = props[names[2]].meta;
  let withError = null;

  if (_.get(phoneNumberMeta, 'touched') && _.get(phoneNumberMeta, 'error')) {
    withError = true;
  } else {
    withError = false;
  }

  return (
    <Forms.PhoneSelect
      className={className}
      id={id}
      key={rerenderKey}
      isRequired={required}
      labelText={label}
      countryValue={countryCodeInput.value || defaultCountry}
      disableTypePicker
      onChange={({ dialCode, iso2, value }) => {
        countryCodeInput.onChange(iso2);
        phoneNumberInput.onChange(format.phone.cleanNumber(value, dialCode));
        countryDialCodeInput.onChange(dialCode);
      }}
      options={options}
      phoneValue={phoneNumberInput.value}
      placeholderText={placeholder}
      withError={withError}
    />
  );
};

FormControlPhoneSelect.propTypes = {
  className: PropTypes.string,
  defaultCountry: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  names: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  rerenderKey: PropTypes.string.isRequired,
};

FormControlPhoneSelect.defaultProps = {
  className: '',
  options: [],
};

export default FormControlPhoneSelect;
